import variables from 'core/styles/variables'
import isValidColor from 'core/helpers/isValidColor'

const USER_TYPES = {
  agent: 'agent',
  borrower: 'borrower',
  admin: 'agent'
}

/** peachy colors */
const themeDefaults = {
  primary: variables.colorBluePrimary,
  secondary: variables.colorBlueSecondary,
  tertiary: variables.colorBlueTertiary,
  lighten: variables.colorBlueLighten
}

const formatTheme = (colors = {}) => {
  // handle previous deeply nested config setup.
  // can remove once that is fully not in use
  const $colors = colors.theme ? colors.theme : colors

  const { primary, secondary, tertiary, lighten } = $colors

  return {
    primary: isValidColor(primary) ? primary : themeDefaults.primary,
    secondary: isValidColor(secondary) ? secondary : themeDefaults.secondary,
    tertiary: isValidColor(tertiary) ? tertiary : themeDefaults.tertiary,
    lighten: isValidColor(lighten) ? lighten : themeDefaults.lighten
  }
}

const parseBoostrapInfo = bootstrapData => {
  const { userType: legacyUserType, appDomainType, company } =
    bootstrapData || {}

  const { id: companyId, timezone, brandAssets } = company || {}

  const { colors } = brandAssets || {}

  const userType =
    USER_TYPES[appDomainType] || appDomainType || legacyUserType || 'borrower'

  const {
    authType: directAuthType,
    authValueType: directAuthValueType,
    ssoUrl: directSsoUrl,
    agentAuthType,
    agentAuthValueType,
    agentSsoUrl,
    borrowerAuthType,
    borrowerAuthValueType,
    borrowerSsoUrl
  } = company || {}

  const authType =
    directAuthType ||
    (userType === 'borrower'
      ? borrowerAuthType
      : userType === 'agent'
      ? agentAuthType
      : null)

  const authValueType =
    directAuthValueType ||
    (userType === 'borrower'
      ? borrowerAuthValueType
      : userType === 'agent'
      ? agentAuthValueType
      : null)

  const ssoUrl =
    directSsoUrl ||
    (userType === 'borrower'
      ? borrowerSsoUrl
      : userType === 'agent'
      ? agentSsoUrl
      : null)

  return {
    appDomainType,
    userType,
    authType,
    authValueType,
    ssoUrl,
    companyId,
    timezone,
    colors,
    company
  }
}

export { parseBoostrapInfo, formatTheme }
